import { Card } from "@/components/reusables/ui/card"
import { H4, Small } from "@/components/standard/BFText"
import { Horizontal, Vertical } from "@/components/standard/BFLayout"
import FolderSimpleMinus from "phosphor-react-native/src/icons/FolderSimpleMinus"
import { BFColors } from "@/constants/Colors"
import { Pressable, View } from "react-native"
import ArrowRight from "phosphor-react-native/src/icons/CaretRight"
import { router } from "expo-router"

export const LoanRequestsAction = ({ loanId }: { loanId: string }) => {
  return (
    <Pressable
      testID="loan-requirements-action"
      onPress={() => {
        router.push(`/loans/${loanId}/requests`)
      }}
    >
      <Card className={"rounded"}>
        <Horizontal className={"items-center"}>
          <View className={"p-4"}>
            <FolderSimpleMinus
              weight={"duotone"}
              color={BFColors.midnightBlue}
              size={24}
            />
          </View>
          <Vertical>
            <H4>Processing Requests</H4>
            <Small>What is needed to move forward</Small>
          </Vertical>
          <View className={"p-4 flex-1 justify-end flex-row pr-6"}>
            <ArrowRight size={20} />
          </View>
        </Horizontal>
      </Card>
    </Pressable>
  )
}
